import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'financial-picture',
  template: require('./financial-picture.component.html')
})
export class FinancialPictureComponent extends BaseRoute {

  constructor(injector: Injector) {
    super(injector);
  }

  updateOptionValue(event) {
    const goalSession = this.flowManager.goalSession;
    if (goalSession.liquidAssets && goalSession.initialInvestment) {
      this.validation.validateForm();
    }
  }

  btnClick(e) {
    if (e.action === 'back' && this.flowManager.isRetirement) {
      this.router.navigate(['retirement'], { queryParamsHandling: 'preserve' });
      return;
    }
    this.handleClick(e.action);
  }
}
